import { ExportConfig } from '@/modules/export/models/ExportConfig';
import { ref, type Ref } from 'vue';

export const json: Ref<Params> = ref(undefined);
export const data: Ref<Params> = ref(undefined);
export const componentType: Ref<Params> = ref(undefined);
export const config: Ref<ExportConfig | undefined> = ref(undefined);
